import React from 'react';
import { Card, Button, message } from 'antd';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import { getUrlSearchParams } from 'utils/utils.js';
import PersonalInfo from '../components/PersonalInfo/Index.js';
import BaseInfo from '../components/BaseInfo/Index.js';
import RelatedSchoolsInfo from '../components/RelatedSchoolsInfo/Index.js';
import styles from './EditOrQuery.less';

@connect()
export default class EditOrQuery extends React.Component {
  constructor(props) {
    super(props);

    this.searchParams = getUrlSearchParams(props.location);

    this.handleGoBack = this.handleGoBack.bind(this);
  }

  componentWillUnmount() {
    this.props.dispatch({ type: 'operationMerchantAddOrUpdate/resetState' });
  }

  handleGoBack() {
    this.props.dispatch(routerRedux.replace('/operation/merchant/list'));
  }

  render() {
    return (
      <section className={styles.root}>
        <PersonalInfo
          type={this.searchParams.type}
          merchantIdForEditOrQuery={this.searchParams.id}
          cardTitle="个人资料"
          className="card"
          submitText="保存"
          successCallback={() => {
            message.success('个人资料保存成功');
          }}
        />
        <BaseInfo
          type={this.searchParams.type}
          merchantIdForEditOrQuery={this.searchParams.id}
          cardTitle="基础资料"
          className="card"
          submitText="保存"
          successCallback={() => {
            message.success('基础资料保存成功');
          }}
        />
        <RelatedSchoolsInfo
          type={this.searchParams.type}
          merchantIdForEditOrQuery={this.searchParams.id}
          cardTitle="关联学校"
          className="card"
          submitText="保存"
          successCallback={() => {
            message.success('关联学校保存成功');
          }}
        />
        <Card bordered={false} className="operation-button-wrap">
          <Button onClick={this.handleGoBack}>返回</Button>
        </Card>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/Merchant/Detail/EditOrQuery.js